import * as XLSX from 'xlsx';

const exportToExcel = (data, headers, fileName,showSum=false) => {
  const headerKeys = Object.keys(headers);

  // Format data dynamically based on headers
  const formattedData = showSum ? data.map((item, index) =>
    headerKeys.reduce((acc, key, i) => {
      acc[key] = i === 0
      ? item?.serialNumber || index + 1 // if serialNumber is 'Total', use it; else use index+1
      : item[headers[key]];
      return acc;
    }, {})
  ): data.map((item, index) =>
    headerKeys.reduce((acc, key, i) => {
      acc[key] = i === 0 ? index + 1 : item[headers[key]]; // Add S.No automatically
      return acc;
    }, {})
  );

  const worksheet = XLSX.utils.json_to_sheet(formattedData);
  XLSX.utils.sheet_add_aoa(worksheet, [headerKeys], { origin: 'A1' });

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

  XLSX.writeFile(workbook, fileName);
};

export default exportToExcel;
